import { claudeConstants } from '../_constants';

export function claude_launch(state = {}, action) {
  switch (action.type) {
    case claudeConstants.LAUNCH_REQUEST:
      return {
        loading: true
      };
    case claudeConstants.LAUNCH_SUCCESS:
      return {
        item: action.launch
      };
    case claudeConstants.LAUNCH_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}

export function claude_history(state = {}, action) {
  switch (action.type) {
    case claudeConstants.HISTORY_REQUEST:
      return {
        loading: true
      };
    case claudeConstants.HISTORY_SUCCESS:
      return {
        items: action.claude_history.data
      };
    case claudeConstants.HISTORY_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}

export function claude_logs(state = {}, action) {
  switch (action.type) {
    case claudeConstants.LOGS_REQUEST:
      return {
        loading: true
      };
    case claudeConstants.LOGS_SUCCESS:
      return {
        items: action.claude_logs.data
      };
    case claudeConstants.LOGS_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}

/*
export function claude(state = {}, action) {
  switch (action.type) {
    case claudeConstants.CANCEL_REQUEST:
      return {
        loading: true
      };
    case claudeConstants.CANCEL_SUCCESS:
      return {
        loading: true
      };
    case claudeConstants.CANCEL_FAILURE:
      return {
        loading: true
      };
    case claudeConstants.CANCEL_BATCH_REQUEST:
      return {
        loading: true
      };
    case claudeConstants.CANCEL_BATCH_SUCCESS:
      return {
        loading: true
      };
    case claudeConstants.CANCEL_BATCH_FAILURE:
      return {
        loading: true
      };
    case claudeConstants.RETRY_BATCH_REQUEST:
      return {
        loading: true
      };
    case claudeConstants.RETRY_BATCH_SUCCESS:
      return {
        loading: true
      };
    case claudeConstants.RETRY_BATCH_FAILURE:
      return {
        loading: true
      };
    default:
      return state
  }
}
*/